import { render, staticRenderFns } from "./HomeScreenKiosk.vue?vue&type=template&id=635782e0&"
import script from "./HomeScreenKiosk.vue?vue&type=script&lang=js&"
export * from "./HomeScreenKiosk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports